import './index.css.proxy.js';
/* src/routes/canvas/index.svelte generated by Svelte v3.31.0 */
import {
	SvelteComponent,
	append,
	attr,
	children,
	claim_element,
	claim_space,
	claim_text,
	detach,
	element,
	init,
	insert,
	noop,
	query_selector_all,
	safe_not_equal,
	space,
	text
} from "../../../web_modules/svelte/internal.js";

function create_fragment(ctx) {
	let t0;
	let h3;
	let t1;
	let t2;
	let ul;
	let a0;
	let li0;
	let t3;
	let t4;
	let a1;
	let li1;
	let t5;
	let t6;
	let a2;
	let li2;
	let t7;

	return {
		c() {
			t0 = space();
			h3 = element("h3");
			t1 = text("canvas");
			t2 = space();
			ul = element("ul");
			a0 = element("a");
			li0 = element("li");
			t3 = text("editor");
			t4 = space();
			a1 = element("a");
			li1 = element("li");
			t5 = text("wasm");
			t6 = space();
			a2 = element("a");
			li2 = element("li");
			t7 = text("shell");
			this.h();
		},
		l(nodes) {
			const head_nodes = query_selector_all("[data-svelte=\"svelte-9dknz2\"]", document.head);
			head_nodes.forEach(detach);
			t0 = claim_space(nodes);
			h3 = claim_element(nodes, "H3", {});
			var h3_nodes = children(h3);
			t1 = claim_text(h3_nodes, "canvas");
			h3_nodes.forEach(detach);
			t2 = claim_space(nodes);
			ul = claim_element(nodes, "UL", { class: true });
			var ul_nodes = children(ul);
			a0 = claim_element(ul_nodes, "A", { href: true });
			var a0_nodes = children(a0);
			li0 = claim_element(a0_nodes, "LI", { class: true });
			var li0_nodes = children(li0);
			t3 = claim_text(li0_nodes, "editor");
			li0_nodes.forEach(detach);
			a0_nodes.forEach(detach);
			t4 = claim_space(ul_nodes);
			a1 = claim_element(ul_nodes, "A", { href: true });
			var a1_nodes = children(a1);
			li1 = claim_element(a1_nodes, "LI", { class: true });
			var li1_nodes = children(li1);
			t5 = claim_text(li1_nodes, "wasm");
			li1_nodes.forEach(detach);
			a1_nodes.forEach(detach);
			t6 = claim_space(ul_nodes);
			a2 = claim_element(ul_nodes, "A", { href: true });
			var a2_nodes = children(a2);
			li2 = claim_element(a2_nodes, "LI", { class: true });
			var li2_nodes = children(li2);
			t7 = claim_text(li2_nodes, "shell");
			li2_nodes.forEach(detach);
			a2_nodes.forEach(detach);
			ul_nodes.forEach(detach);
			this.h();
		},
		h() {
			document.title = "Canvas • clp.is";
			attr(li0, "class", "svelte-1wu7mov");
			attr(a0, "href", "/canvas/editor");
			attr(li1, "class", "svelte-1wu7mov");
			attr(a1, "href", "/canvas/wasm");
			attr(li2, "class", "svelte-1wu7mov");
			attr(a2, "href", "/canvas/shell");
			attr(ul, "class", "svelte-1wu7mov");
		},
		m(target, anchor) {
			insert(target, t0, anchor);
			insert(target, h3, anchor);
			append(h3, t1);
			insert(target, t2, anchor);
			insert(target, ul, anchor);
			append(ul, a0);
			append(a0, li0);
			append(li0, t3);
			append(ul, t4);
			append(ul, a1);
			append(a1, li1);
			append(li1, t5);
			append(ul, t6);
			append(ul, a2);
			append(a2, li2);
			append(li2, t7);
		},
		p: noop,
		i: noop,
		o: noop,
		d(detaching) {
			if (detaching) detach(t0);
			if (detaching) detach(h3);
			if (detaching) detach(t2);
			if (detaching) detach(ul);
		}
	};
}

class Canvas extends SvelteComponent {
	constructor(options) {
		super();
		init(this, options, null, create_fragment, safe_not_equal, {});
	}
}

export default Canvas;
//# sourceMappingURL=index.js.map
